export const deserializePaymentMethods = (method) => ({
  id: method.id,
  type: method.attributes?.type || method.type,
  label: method.attributes?.name || method.name,
  description: method.attributes?.description || method.description,
  preferences: method.attributes?.preferences || method.preferences,
})
